import { AgencyService } from '@/services/agency-service'
import { NativeSelect, Option, SelectOption } from '@tempots/beatui'
import { attr, html, OneOfValue, Signal, Use } from '@tempots/dom'
import { Location, Query } from '@tempots/ui'

/**
 * Pure agency-context indicator/switcher. Navigation "home" is handled by the
 * explicit Workspace nav link (and the logo), so a single agency renders as a
 * plain label rather than a link.
 */
export function AgencySelector({ agencyId }: { agencyId: Signal<string> }) {
  return Query({
    request: null,
    load: () => AgencyService.listUserAgencies(),
    success: ({ value: agencies }) => {
      const selection = agencies.map(({ total }) =>
        total === 0 ? 'none' : total === 1 ? 'one' : 'many'
      )
      return OneOfValue(selection, {
        none: () =>
          html.div(
            attr.class('text-gray-400 font-semibold text-sm whitespace-nowrap'),
            'No agency'
          ),
        one: () => {
          const agency = agencies.$.agencies.$[0]
          return html.div(
            attr.class('text-gray-800 font-semibold text-sm whitespace-nowrap'),
            agency.$.name
          )
        },
        many: () =>
          Use(Location, location =>
            NativeSelect({
              value: agencyId,
              onChange: value => {
                AgencyService.updatePreferredAgency(value)
                location.navigate('/start')
              },
              options: agencies.$.agencies.map(agencies =>
                agencies.map(
                  agency =>
                    Option.value(agency.id, agency.name) as SelectOption<string>
                )
              ),
            })
          ),
      })
    },
  })
}
